import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Box from '../../Box/Box';
import Money from '../../Common/Money/Money';
import PlusIcon from '../../icons/PlusIcon';
import styles from '../Summary/summary.module.css';

const Commission = ({ subtotal, percentage, discount, discountPercentage, total }) => {
  const { t } = useTranslation();
  const currency = useSelector((state) => state.currency.default);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenBox = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div
        className='section-title d-flex align-items-center'
        onClick={handleOpenBox}
        style={{ gap: '5px', cursor: 'pointer' }}
      >
        {t('yourCommission')} <PlusIcon size={16} color='var(--color-primary)' />
      </div>
      <div className={['box-wrapper', isOpen ? 'show' : ''].join(' ')}>
        <Box>
          <div className='text-secondary font-extra-small capitalize'>{t('commissionDetail')}</div>
          <div className='row mt-2 text-tertiary font-small'>
            <div className='col pr-0'>{t('commissionBase', { percentage: percentage })}:</div>
            <div className='col-auto'>
              <Money
                value={subtotal}
                convert={false}
                lowDecimals
                decimal={false}
                symbol={currency.symbol}
                currencyCode={currency.shortForm}
              />
            </div>
          </div>

          {discount < 0 && (
            <div className='row mt-2 text-tertiary font-small'>
              <div className='col pr-0'>
                {t('appliedDiscount')} ({discountPercentage}%):
              </div>
              <div className='col-auto'>
                <Money
                  value={discount}
                  convert={false}
                  lowDecimals
                  decimal={false}
                  symbol={currency.symbol}
                  currencyCode={currency.shortForm}
                />
              </div>
            </div>
          )}

          <div className={`${styles.total} text-success fw-600`}>
            <div className='row'>
              <div className='col pr-0'>{t('finalCommission')}:</div>
              <div className='col-auto'>
                <Money
                  value={total}
                  convert={false}
                  lowDecimals
                  decimal={false}
                  symbol={currency.symbol}
                  currencyCode={currency.shortForm}
                />
              </div>
            </div>
          </div>
          <div
            className='text-secondary font-tiny fw-500 mt-2'
            dangerouslySetInnerHTML={{ __html: t('commissionCalculation') }}
          />
        </Box>
      </div>
    </>
  );
};

export default Commission;
